module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "md-flex",
    attrs: {
      "id": "actions"
    }
  }, [_c('md-content', {
    staticClass: "md-layout-row md-gutter md-elevation-1",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('module-menu'), _c('div', {
    staticClass: "md-flex",
    attrs: {
      "md-theme": "white"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78e66e51","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/module/views/Module.vue
// module id = 1200
// module chunks = 0